import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  FormHelperText 
} from '@mui/material';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';

/**
 * Component for selecting a collection type
 */
const CollectionTypeSelect = ({ value, onChange, label, helperText, includeWishlists = true }) => {
  const { featureFlags } = useFeatureFlags();
  
  const collectionTypes = [
    { value: 'games', label: 'Games Collection' },
    { value: 'consoles', label: 'Consoles Collection' },
    { value: 'legoSets', label: 'LEGO Sets Collection' }
  ];
  
  const wishlistTypes = [
    { value: 'game-wishlist', label: 'Games Wishlist' },
    { value: 'console-wishlist', label: 'Consoles Wishlist' },
    { value: 'lego-wishlist', label: 'LEGO Sets Wishlist' }
  ];
  
  // Add movie collections and wishlists if enabled
  if (featureFlags.enableMoviesFeature) {
    collectionTypes.push({ value: 'movies', label: 'Movies Collection' });
    if (includeWishlists) {
      wishlistTypes.push({ value: 'movie-wishlist', label: 'Movies Wishlist' });
    }
  }
  
  // Add music collections and wishlists if enabled
  if (featureFlags.enableMusicFeature) {
    collectionTypes.push({ value: 'music', label: 'Music Collection' });
    if (includeWishlists) {
      wishlistTypes.push({ value: 'music-wishlist', label: 'Music Wishlist' });
    }
  }

  // Add book collections and wishlists if enabled
  if (featureFlags.enableBooksFeature) {
    collectionTypes.push({ value: 'books', label: 'Books Collection' });
    if (includeWishlists) {
      wishlistTypes.push({ value: 'book-wishlist', label: 'Books Wishlist' });
    }
  }
  
  // Combine collection types and wishlist types
  const options = [...collectionTypes];
  if (includeWishlists) {
    options.push(...wishlistTypes);
  }
  
  return (
    <FormControl fullWidth>
      <InputLabel id="collection-type-select-label">{label || 'Collection Type'}</InputLabel>
      <Select
        labelId="collection-type-select-label"
        value={value}
        label={label || 'Collection Type'}
        onChange={onChange}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CollectionTypeSelect;
